import { AbstractReactFactory } from "@projectstorm/react-canvas-core";
import { DefaultNodeModel } from "@projectstorm/react-diagrams";
import { DiagramEngine } from "@projectstorm/react-diagrams-core";
import { CustomNodeModel } from "./CustomNodeModel";
import { CustomNodeWidget } from "./CustomNodeWidget";

export class CustomNodeFactory extends AbstractReactFactory<CustomNodeModel, DiagramEngine> {
  constructor() {
    super("custom");
  }

  generateReactWidget(event): JSX.Element {
    return <CustomNodeWidget engine={this.engine} size={150} node={event.model} />;
  }

  generateModel() {
    return new DefaultNodeModel();
  }
}
